<div class="detail-card">
  <div class="d-flex flex-column gap-1">
    <div class="title">{{ title }}</div>
    <div class="detail" i18n>
      Payment in
      {{ formattedMonthYear }}
    </div>
  </div>

  <div class="d-flex flex-column gap-1">
    <div class="value">{{ amount | currency }}</div>
  </div>
</div>
